import { useTohonBuy } from "../../context/TohonBuyContext";
import { useAuthStatus } from "../../context/AuthContext";

// 地番文字列を作成するヘルパー関数
const createChibanStr = (oaza, chome, koaza, yobi, chiban) => {
  return `${oaza || ""}${chome || ""}${koaza || ""}${yobi || ""}${
    chiban || ""
  }`;
};

const TohonBuyListTable = ({ isMainMap }) => {
  const { tohonBuyList, removeTohon } = useTohonBuy();
  const { isUserLoggedIn } = useAuthStatus();

  const handleRemove = (item) => {
    if (!isUserLoggedIn) {
      window.dispatchEvent(
        new CustomEvent("showLoginPrompt", {
          detail: { showButton: isMainMap },
        })
      );
      return;
    }
    removeTohon(item);
  };

  if (tohonBuyList.length === 0) {
    return null; // リストが空の場合は何も表示しない
  }

  return (
    <table className="table TohonListTableInLeftSlider">
      <thead>
        <tr>
          <th className="align-middle">#</th>
          <th className="align-middle">
            不動産登記情報（土地）
            <br />
            購入リスト
          </th>
          <th className="align-middle">削除</th>
        </tr>
      </thead>
      <tbody>
        {tohonBuyList.map((item, index) => (
          <tr key={index}>
            <th className="align-middle">{index + 1}</th>
            <td className="align-middle">
              {createChibanStr(
                item.oaza,
                item.chome,
                item.koaza,
                item.yobi,
                item.chiban
              )}
            </td>
            <td className="align-middle">
              <button
                className="btn btn-link"
                onClick={() => handleRemove(item)}
              >
                <i
                  className="fa fa-trash"
                  style={{ color: "#555555", fontSize: "20px" }}
                  aria-hidden="true"
                ></i>
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TohonBuyListTable;
